<template>
  <div class="big chufang-detail">
    <div class="page_title flex_between">
      <span>患者售后申请详情</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="inbobox">
          <div class="inboitem">
            <div>
              <span class="infotitle">助理姓名：</span>
              <span>{{ detail.ass_name }}</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ detail.ass_phone }}</span>
            </div>
          </div>
          <div class="inboitem">
            <div style="display: flex">
              <div>
                <span class="infotitle">医生姓名：</span>
                <span>{{ detail.doctor_name }}</span>
              </div>
              <div style="margin: 0 50px">
                <span>性别：</span>
                <span v-if="detail.sex == 1">男</span>
                <span v-if="detail.sex == 2">女</span>
                <span v-if="detail.sex == 0">未知</span>
              </div>
              <div>
                <span>手机号：</span>
                <span>{{ detail.doctor_phone }}</span>
              </div>
            </div>

            <div>
              <span style="display:inline-block;width:182px">
                <span style="margin-right:20px">职称：</span>
                <span>{{ detail.title }}</span>
              </span>
              <span>
                <span style="margin-right:20px">科室：</span>
                <span>{{ detail.department_name }}</span>
              </span>
            </div>

          </div>
        </div>
        <div>
          <span class="title">
            是否绑定歧黄助手
          </span>
          <span v-if="detail.bind_wx">
            是
          </span>
          <span v-else>否</span>
        </div>
        <div style="margin:20px 0">
          <span class="title">
            微信昵称
          </span>
          <span style="margin-right:30px">
            {{detail.nick_name}}
          </span>
          <el-button
            type="primary"
            size="medium"
            v-if="detail.nick_name"
            @click="unbound"
            :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('754')
                      : false
                  "
          >解绑</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pre_img: false,
      sign_img: false,
      detail: {},
      drugs_list: [],
      oil_list: [],
      pm_list: [],
      recipeDetailDialog: false,
      relevanceRecipe: [],
      relevanceInfo: {},
      is_show: false
    };
  },
  filters: {
    preGroupText(val) {
      switch (val) {
        case 1:
          return '中药材';
        case 2:
          return '养生方';
        case 3:
          return '成药';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取详情
    getDetail() {
      let bind_id = this.$route.query.bind_id;
      this.axios
        .post('platform/assistant/doctorAssistantsInfo', { bind_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
          }
        });
    },
    //取消绑定
    unbound() {
      this.axios
        .post('platform/assistant/unboundDoctorAssistants', {
          bind_id: this.detail.bind_id
        })
        .then((res) => {
          this.$message.success('解绑成功');
          this.getDetail();
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}
.inbobox {
  display: flex;
  margin-bottom: 20px;
  height: 90px;
  .inboitem {
    padding: 14px 50px 14px 20px;
    box-sizing: border-box;
    margin-right: 20px;
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .infotitle {
      width: 90px;
      display: inline-block;
    }
  }
}
.title {
  font-size: 15px;
  font-weight: 700;
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 30px;
}
</style>
